import React from 'react';

const STATUS_LABELS = {
    draft: 'Draft',
    sent: 'Sent',
    viewed: 'Viewed',
    partially_paid: 'Partially Paid',
    pending_settlement: 'Pending Settlement',
    paid: 'Paid',
    overdue: 'Overdue',
    void: 'Void',
    canceled: 'Canceled',
    refunded: 'Refunded',
    partially_refunded: 'Partially Refunded',
    uncollectible: 'Uncollectible',
};

const STATUS_CLASS = {
    draft: 'status-draft',
    sent: 'status-sent',
    viewed: 'status-viewed',
    partially_paid: 'status-partial',
    pending_settlement: 'status-pending-settlement',
    paid: 'status-paid',
    overdue: 'status-overdue',
    void: 'status-void',
    canceled: 'status-canceled',
    refunded: 'status-refunded',
    partially_refunded: 'status-partial-refunded',
    uncollectible: 'status-uncollectible',
};

function fmtCents(cents, currency = 'USD') {
    return `${(cents / 100).toFixed(2)} ${currency}`;
}

function fmtDate(d) {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

function InvoicesTable({ invoices, onView, onRefresh }) {
    if (!invoices || invoices.length === 0) return null;

    return (
        <div className="invoices-table-wrapper">
            <table className="invoices-table">
                <thead>
                    <tr>
                        <th>Invoice #</th>
                        <th>Status</th>
                        <th>Customer</th>
                        <th>Total</th>
                        <th>Due</th>
                        <th>Amount Due</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {invoices.map(invoice => (
                        <tr key={invoice.uuid} className={STATUS_CLASS[invoice.status]}>
                            <td data-label="Invoice #">
                                {invoice.invoiceNumber
                                    ? <span className="invoice-number">#{invoice.invoiceNumber}</span>
                                    : <span className="invoice-id muted">{invoice.uuid.slice(0, 8)}…</span>
                                }
                            </td>
                            <td data-label="Status">
                                <span className={`status-badge ${STATUS_CLASS[invoice.status] || ''}`}>
                                    {STATUS_LABELS[invoice.status] || invoice.status}
                                </span>
                            </td>
                            <td data-label="Customer">
                                {invoice.customerSnapshot?.name || invoice.customerSnapshot?.email || '—'}
                            </td>
                            <td data-label="Total">{fmtCents(invoice.totalCents, invoice.currency)}</td>
                            <td data-label="Due Date">{fmtDate(invoice.dueAt)}</td>
                            <td data-label="Amount Due">
                                {invoice.amountDueCents > 0
                                    ? <strong>{fmtCents(invoice.amountDueCents, invoice.currency)}</strong>
                                    : <span className="muted">Paid</span>
                                }
                            </td>
                            <td data-label="Created">{fmtDate(invoice.createdAt)}</td>
                            <td data-label="View and Manage">
                                <button
                                    className="button small"
                                    onClick={() => onView(invoice)}
                                >
                                    View
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default InvoicesTable;
